import React from "react";

const Button = ({ children, className = "", ...rest }) => {
  return (
    <button
      type="button"
      style={{ letterSpacing: 0.4 }}
      className={`bg-primary text-main text-center font-medium !font-railway rounded-[50px] border-[2px] border-main px-6 py-1.5 ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
